module.exports = __webpack_public_path__ + "static/media/anniversary_flyer.f9543098.png";